module.exports = __webpack_public_path__ + "img/bg-dot-pattern.4b623b3b.svg";